module.exports = __webpack_public_path__ + "img/image10.06db41d3.jpg";